import { render } from "./Dashboard.vue?vue&type=template&id=3384150c&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=3384150c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3384150c"

export default script